import { render, staticRenderFns } from "./IdiomSubNav.vue?vue&type=template&id=fed6c112&scoped=true&"
import script from "./IdiomSubNav.vue?vue&type=script&lang=js&"
export * from "./IdiomSubNav.vue?vue&type=script&lang=js&"
import style0 from "./IdiomSubNav.vue?vue&type=style&index=0&id=fed6c112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed6c112",
  null
  
)

export default component.exports